import AbstractService, {
  InterfaceClient,
  ServiceClient,
  ModelClient
} from "./AbstractService";

/**
 * AuthService
 */
export default class ClientService extends AbstractService implements InterfaceClient {
  /**
   * ServiceAuth
   */
  static service: ServiceClient;

  /**
   * constructor
   */
  constructor() {
    super();

    ClientService.service = this.getApi().getServiceClient();
  }

  /**
   * create
   * @param client
   */
  create(client: ModelClient): Promise<ModelClient> {
    return ClientService.service.create(client);
  }

  /**
   * getAll
   */
  getAll(): Promise<ModelClient[]> {
    return ClientService.service.getAll();
  }

  /**
   * getDatatable
   */
  getDatatable(tableParameter = {}): Promise<any> {
    return ClientService.service.getDatatable(tableParameter);
  }

  /**
   * getById
   * @param id
   */
  getById(id: string): Promise<ModelClient> {
    return ClientService.service.getById(id);
  }

  /**
   * update
   * @param id
   * @param client
   */
  update(id: string, client: ModelClient): Promise<ModelClient> {
    return ClientService.service.update(id, client);
  }

  /**
   * update
   * @param id
   * @param data
   */
  test(id: string, data: any): Promise<any> {
    return ClientService.service.test(id, data);
  }

  /**
   * testPartner
   * @param partnerId
   * @param data
   */
  testPartner(partnerId: string, data: any): Promise<any> {
    return ClientService.service.testPartner(partnerId, data);
  }
}
